'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var symbols = require('./lib/symbols');

var number = require('./lib/number');

var string = require('./lib/string');

var object = require('./lib/object');

var typePredicates = {
  number: number,
  string: string,
  object: object
};

var createOw = function createOw() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$validators = _ref.validators,
      validators = _ref$validators === void 0 ? [] : _ref$validators,
      _ref$predicates = _ref.predicates,
      predicates = _ref$predicates === void 0 ? typePredicates : _ref$predicates,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? null : _ref$type;

  var ow = new Proxy(function () {}, {
    get: function get(obj, key) {
      if (key === symbols.validate) {
        return function (value) {
          var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'argument';

          if (!type) {
            return new Error('missing required type specifier');
          }

          for (var i = 0; i < validators.length; ++i) {
            var validator = validators[i];
            var result = validator.fn(value);

            if (!result) {
              if (i === 0) {
                throw new Error("Expected ".concat(label, " `").concat(value, "` to be of type `").concat(type, "`, but received type `").concat(typeof value, "`"));
              } else {
                throw new Error("Expected ".concat(type, " `").concat(label, "` `").concat(value, "` failed predicate `").concat(validator.key, "`"));
              }
            }
          }
        };
      }

      var predicate = predicates[key];

      if (predicate) {
        if (typeof predicate === 'function') {
          validators.push({
            key: key,
            fn: predicate
          });
          return ow;
        } else {
          return createOw({
            type: key,
            validators: [{
              key: key,
              fn: predicate.validator
            }],
            predicates: predicate.predicates
          });
        }
      } else {
        var fn = predicates[symbols.func] && predicates[symbols.func][key];

        if (fn) {
          return new Proxy(function () {}, {
            get: function get() {
              throw new Error("invalid use of functional predicate \"".concat(key, "\""));
            },
            apply: function apply(obj, thisArg, args) {
              validators.push({
                key: key,
                fn: fn.apply(void 0, _toConsumableArray(args))
              });
              return ow;
            }
          });
        } else {
          if (key === 'default' || key === '__esModule') {
            return ow;
          }

          return ow; // throw new Error(`unrecognized predicate "${key}"`)
        }
      }
    },
    apply: function apply(obj, thisArg, args) {
      if (args.length !== 2 && args.length !== 3) {
        throw new Error('invalid number of arguments to "ow"');
      } else {
        args[1][symbols.validate](args[0], args[2]);
      }
    }
  });
  return ow;
};

module.exports = createOw();